var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaytechDice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    fillRule: "evenodd",
    d: "M13.033 6.776a2.042 2.042 0 01-.76 2.805l-5.4 3.08a2.092 2.092 0 01-2.84-.75l-3.12-5.34a2.04 2.04 0 01.76-2.804l5.4-3.081a2.094 2.094 0 012.84.75l3.12 5.34zM4.319 5.222a1.043 1.043 0 00-1.045-.491c-.417.06-.756.364-.858.768a1.02 1.02 0 00.393 1.075 1.05 1.05 0 001.628-.578 1.01 1.01 0 00-.118-.774zm1.564 3.94c.417-.055.826.144 1.036.504a1.02 1.02 0 01-.38 1.403c-.364.208-.82.178-1.153-.074a1.02 1.02 0 01-.372-1.081c.109-.401.451-.699.869-.753zm.69-5.224c-.21-.36-.62-.56-1.037-.505-.417.054-.76.352-.869.753-.109.401.038.828.372 1.08a1.05 1.05 0 001.64-.548 1.01 1.01 0 00-.106-.78zm1.563 3.94c.417-.055.826.144 1.037.504a1.022 1.022 0 01-.38 1.403c-.365.208-.82.179-1.154-.074a1.021 1.021 0 01-.372-1.08c.109-.402.452-.7.869-.754zm.69-5.224a1.045 1.045 0 00-1.906.248c-.108.401.039.828.372 1.08.334.254.79.283 1.154.075a1.02 1.02 0 00.38-1.403zm1.18 4.07a1.053 1.053 0 011.42.374c.21.36.181.81-.075 1.14-.256.33-.688.474-1.094.367a1.023 1.023 0 01-.252-1.882z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    fillRule: "evenodd",
    d: "M8.826 2.654c.215.358.19.808-.063 1.141a1.045 1.045 0 01-1.861-.475c-.058-.412.14-.818.504-1.028a1.054 1.054 0 011.42.362zM6.573 3.938c.21.36.181.81-.075 1.14a1.05 1.05 0 01-1.094.367 1.033 1.033 0 01-.763-.859 1.023 1.023 0 01.512-1.023 1.046 1.046 0 011.42.375zM4.437 5.996a1.006 1.006 0 00-.118-.774h.027c-.21-.36-.62-.56-1.036-.505-.418.054-.76.351-.87.753a1.02 1.02 0 00.373 1.08 1.05 1.05 0 001.153.074c.236-.14.405-.365.471-.628zm2.408 4.81c.256-.33.285-.78.074-1.14-.136-.237-.363-.41-.63-.48s-.551-.033-.79.105a1.022 1.022 0 00.251 1.882c.407.107.839-.038 1.095-.368zM9.098 9.52c.256-.33.285-.779.075-1.139a1.03 1.03 0 00-.63-.48 1.047 1.047 0 00-.79.105 1.025 1.025 0 00-.512 1.024c.055.412.356.75.763.858.406.107.838-.038 1.094-.368zm2.253-1.284c.256-.33.286-.779.075-1.139a1.048 1.048 0 00-1.42-.375 1.024 1.024 0 00-.511 1.024c.055.412.356.75.762.858.407.107.838-.038 1.094-.368z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    fillRule: "evenodd",
    d: "M21.593 3.767a2.04 2.04 0 01.76 2.805l-3.12 5.34a2.096 2.096 0 01-2.84.75l-5.4-3.081a2.04 2.04 0 01-.76-2.805l3.12-5.34a2.094 2.094 0 012.84-.75l5.4 3.08zm-8.334 2.956a1.05 1.05 0 00-1.153.074c-.334.253-.48.68-.372 1.08.109.402.452.7.869.754.417.054.826-.146 1.037-.505.14-.236.178-.517.106-.78a1.02 1.02 0 00-.487-.623zm3.354 2.642a1.05 1.05 0 011.153-.074c.497.284.667.911.38 1.402-.21.36-.62.56-1.036.505a1.021 1.021 0 01-.497-1.833zM14.56 4.498a1.047 1.047 0 00-1.419.377 1.02 1.02 0 00.378 1.402 1.047 1.047 0 001.42-.37 1.018 1.018 0 00-.38-1.409zm3.088 2.944c.287-.49.921-.658 1.418-.376.495.288.664.915.38 1.408-.29.49-.924.655-1.42.37a1.02 1.02 0 01-.378-1.402zm-1.788-5.15a1.051 1.051 0 00-1.154.074c-.334.253-.48.68-.372 1.08a1.045 1.045 0 001.906.249 1.022 1.022 0 00-.38-1.403zm3.347 2.635c.336-.253.795-.28 1.16-.067v-.013c.237.135.411.358.482.62.072.262.035.54-.103.776a1.041 1.041 0 01-1.034.52 1.037 1.037 0 01-.879-.75c-.11-.403.037-.833.374-1.086z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    fillRule: "evenodd",
    d: "M15.859 2.292c.364.208.566.612.511 1.024-.055.412-.355.75-.762.858a1.05 1.05 0 01-1.094-.367 1.017 1.017 0 01-.075-1.14 1.03 1.03 0 01.63-.48c.267-.07.552-.033.79.105zm-1.3 2.206c.498.282.671.909.386 1.401-.285.492-.92.663-1.42.382a1.021 1.021 0 01-.386-1.401 1.048 1.048 0 011.42-.382zm-.789 3.249a1.024 1.024 0 00-.511-1.024 1.054 1.054 0 00-1.42.375c-.21.36-.181.81.075 1.14.256.33.688.474 1.094.367a1.03 1.03 0 00.762-.858zm4.507 2.568a1.024 1.024 0 00-.511-1.024 1.054 1.054 0 00-1.42.375c-.211.36-.181.81.074 1.14.256.33.688.474 1.095.367.406-.108.707-.446.762-.858zm1.185-1.83c.288-.5.11-1.136-.396-1.42v.027a1.05 1.05 0 00-1.424.378 1.023 1.023 0 00.384 1.406 1.06 1.06 0 001.436-.392zm1.415-2.601a1.024 1.024 0 00-.511-1.024v-.013a1.052 1.052 0 00-.792-.097 1.036 1.036 0 00-.628.485c-.211.36-.181.81.074 1.14.256.33.688.474 1.095.367.406-.108.707-.446.762-.858z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.78,
    x2: -1.943,
    y1: -2.188,
    y2: 11.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AAC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.851,
    x2: 10.292,
    y1: 9.868,
    y2: 14.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.241,
    x2: 10.964,
    y1: 1.54,
    y2: 15.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A82775"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.052,
    x2: 23.138,
    y1: 13.272,
    y2: 11.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C58600"
  })))));
}
SvgPlaytechDice.displayName = 'PlaytechDice';
export default SvgPlaytechDice;